import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import axios from '@/services'
import lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'
import { useAuthStore } from '@/stores/auth'

const setSponsorInfo = async () => {
  const formStore = useFormStore()
  const { fileNumber, personAddress, genderId, nationalityId, unifiedNumber } =
    formStore.draft.request.individualInfo
  formStore.draft.request = {
    ...formStore.draft.request,
    sponsorFileNumber: fileNumber,
    sponsorAddress: personAddress,
    sponsorGenderId: genderId,
    sponsorNationalityId: nationalityId,
    sponsorNumber: unifiedNumber
  }
}

const prepareEstabAddress = async () => {
  const formStore = useFormStore()
  const { referenceRequestNumber } = formStore.form.values || {}
  if (referenceRequestNumber) {
    return
  }

  const result = await apiHelperService.get(
    '/api/addressesBook/formComponent/mapAndPrepareAddressForVisaRequest'
  )
  formStore.draft.request = {
    ...formStore.draft.request,
    localUserAddressId: result.localUserAddressId,
    isHaveNewBehaviorLocalAddress: result.isHaveNewBehaviorLocalAddress,
    localAddressSourceEnum: result.localAddressSourceEnum,
    localAddressUserActionEnum: result.localAddressUserActionEnum,
    localEmirateId: result.localEmirateId,
    localCityId: result.localCityId,
    localAreaId: result.localAreaId,
    localAddress: result.localAddress,
    localHomePhone: result.localHomePhone,
    localMobile: result.localMobile,
    emailAddress: result.emailAddress,
    cityId: result.cityId,
    localPobox: result.localPobox,
    buildingName: result.buildingName,
    flatNumber: result.flatNumber,

    // abroad address
    isHaveNewBehaviorAbroadAddress: result.isHaveNewBehaviorAbroadAddress,
    abroadAddressSourceEnum: result.abroadAddressSourceEnum,
    abroadUserAddressId: result.abroadUserAddressId,
    abroadAddressUserActionEnum: result.abroadAddressUserActionEnum,
    abroadCountryId: result.abroadCountryId,
    abroadPhone: result.abroadPhone,
    abroadAddress: result.abroadAddress,

    // Try to complete parameters like their staging env
    eiDorUN: 0,
    applyVisaByNominationRequest: 1
  }
}

const checkIsShowCardReader = () => {
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()
  // Check is show card reader or not
  if (
    globalStore?.startedService?.serviceConfig?.ismultipleEntryLongTermTourism &&
    authStore.isUserTypingCenter
  ) {
    formStore.extraMap.isReadDataFromCard = false
  }
}

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()

  checkIsShowCardReader()
  const { serviceTransactionId } = globalStore.startedService
  const {
    fileNumber = '',
    administrativeRegionId = '',
    withException = '',
    immigrationDepartmentId = '',
    sponsorTypeId = ''
  } = router.currentRoute.value.query
  const {
    entryStatus: { outsideUae }
  } = lookups
  formStore.extraMap = {
    ...formStore.extraMap,
    visaDuarationMsg: '',
    serviceTransactionId,
    administrativeRegionId,
    immigrationDepartmentId,
    sponsorTypeId,
    withException: withException == 'true',
    isInCompleteDraftFlag: false,
    hideNominationInfoForSelectedReason: false,
    isNominationRequestValid: false
  }
  if (fileNumber) {
    let res = await axios.request({
      url: `/api/individual/visa/${fileNumber}`,
      method: 'GET'
    })
    if (res) {
      formStore.draft.request = {
        ...formStore.draft.request,
        ...res,
        sponsoredEntryStatus: outsideUae
      }
    }
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    if ([413, 632, 633, 635, 636, 639, 753, 1104, 1105].includes(serviceTransactionId)) {
      setDefaultVal(res)
    }
    formStore.draft.request.individualInfo = res
    formStore.extraMap.individualInfo = res
  }
}

const setDefaultVal = (res) => {
  const formStore = useFormStore()
  const {
    unifiedNumber = '',
    fileDepartmentCode = '',
    fileYear = '',
    fileCode = '',
    fileSequence = '',
    englishFullName = '',
    arabicFullName = '',
    dateOfBirth = '',
    englishPlaceOfBirth = '',
    arabicPlaceOfBirth = '',
    englishMotherName = '',
    arabicMotherName = '',
    passportNumber = '',
    passportEnglishIssuePlace = '',
    passportArabicIssuePlace = '',
    passportIssueDate = '',
    passportExpiryDate = '',
    faithId = '',
    religionId = '',
    professionId = '',
    educationLevelId = '',
    passportTypeId = '',
    passportCountryId = '',
    countryOfBirthId = '',
    genderId = '',
    previousNationalityId = '',
    familyRelationshipId = '',
    nationalityId = '',
    martialStatusId = ''
  } = res

  formStore.draft.request = {
    ...formStore.draft.request,
    personUnifiedNumber: unifiedNumber,
    departmentCode: fileDepartmentCode,
    serviceYear: fileYear,
    serviceCode: fileCode,
    sequenceNumber: fileSequence,
    englishName: englishFullName,
    arabicName: arabicFullName,
    englishPlaceOfBirth,
    arabicPlaceOfBirth,
    englishMotherName,
    arabicMotherName,
    passportNumber,
    passportEnglishIssuePlace,
    passportArabicIssuePlace,
    maritalStatusId: martialStatusId,
    currentNationalityId: nationalityId,
    familyRelationshipId,
    faithId,
    religionId,
    professionId,
    educationLevelId,
    passportTypeId,
    passportCountryId,
    countryOfBirthId,
    genderId,
    previousNationalityId,
    passportIssueDate,
    passportExpiryDate,
    dateOfBirth
  }
}

const setNotesParams = () => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const text =
    formStore?.schema?.steps[0].form.find(
      (item) => item.header === 'notes' && item.device_type != 'mobile'
    )?.schema[0].text || []
  if (Array.isArray(text) && text.length > 0) {
    let days = ''
    switch (serviceTransactionId) {
      case 37:
      case 995:
      case 926:
      case 950:
      case 1005:
      case 1008:
        days = '30'
        break
      case 632:
      case 633:
      case 635:
      case 636:
      case 753:
      case 928:
      case 951:
      case 1006:
      case 1009:
      case 1104:
      case 1105:
        days = '60'
        break
      case 933:
      case 952:
      case 1007:
      case 1010:
        days = '90'
        break
      default:
        break
    }
    text[1].params.visaDuaration = days
  }
}

const showValidityPeriod = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const result = await apiHelperService.get('/api/lookup/getModuleService', {
    params: {
      serviceTransactionId
    }
  })
  if (result) {
    formStore.extraMap.visaDuarationMsg = true
  }
}

const checkNominationRequestProcess = () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { enableNominationRequest, nominationRequestIds } = client_config
  const { isInCompleteDraftFlag } = formStore.extraMap
  formStore.extraMap.enableNominationRequest = false
  if (
    !isInCompleteDraftFlag &&
    enableNominationRequest &&
    nominationRequestIds.includes(+serviceTransactionId)
  ) {
    formStore.extraMap.enableNominationRequest = true
  }
}

export default async function () {
  const authStore = useAuthStore()
  const { applicationId } = authStore.user
  try {
    await initForm()
    if (applicationId != 12) await initInfo()
    await prepareEstabAddress()
    if (applicationId != 12) await setSponsorInfo()
    await setNotesParams()
    await showValidityPeriod()
    await checkNominationRequestProcess()
  } catch (error) {
    console.error('useVisaPreload error: ', error)
  }
}
